import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import {
  collection,
  getCountFromServer,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  startAt,
  where,
} from "firebase/firestore";
import { auth, db } from "src/firebase/firebase";

export const getSupplierCount = async () => {
  const q = await query(
    collection(db, "Accounts"),
    where("accountType", "==", "supplier")
  );
  const snapshot = await getCountFromServer(q);
  const count = snapshot.data().count ?? 0;

  return count >= 10000 ? 10000 : count;
};

export const getSupplier = async (
  pageNumber = -1,
  pageSize = 200,
  text = ""
) => {
  try {
    let q = await query(
      collection(db, "Accounts"),
      where("email", ">=", text),
      where("email", "<=", text + "\uf8ff")
    );

    q = query(q, where("accountType", "==", "supplier"));

    q = query(q, orderBy("email"));

    const startIndex = (pageNumber - 1) * pageSize;

    let firstPageSnapshot;

    if (pageNumber === 1) {
      firstPageSnapshot = await getDocs(query(q, limit(pageSize)));
    } else {
      const startAfterDoc = await getDocs(query(q, limit(startIndex))).then(
        (snapshot) => snapshot.docs[snapshot.docs.length - 1]
      );

      if (!startAfterDoc) {
        return [];
      }

      firstPageSnapshot = await getDocs(
        query(q, startAfter(startAfterDoc), limit(pageSize))
      );
    }

    if (firstPageSnapshot.empty) {
      return [];
    }

    return firstPageSnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const getProcessingTeamCount = async (
  pageNumber = 1,
  pageSize = 200
) => {
  const q = await query(
    collection(db, "Accounts"),
    where("accountType", "==", "processing team")
  );
  const snapshot = await getCountFromServer(q);
  const count = snapshot.data().count ?? 0;

  return count >= 10000 ? 10000 : count;
};

export const getProcessingTeam = async (
  pageNumber = 1,
  pageSize = 200,
  text = ""
) => {
  try {
    let q = await query(
      collection(db, "Accounts"),
      where("email", ">=", text),
      where("email", "<=", text + "\uf8ff")
    );

    q = query(q, where("accountType", "==", "processing team"));

    // q = query(q, orderBy("email"));

    const startIndex = (pageNumber - 1) * pageSize;

    let firstPageSnapshot;

    if (pageNumber === 1) {
      firstPageSnapshot = await getDocs(query(q, limit(pageSize)));
    } else {
      const startAfterDoc = await getDocs(query(q, limit(startIndex))).then(
        (snapshot) => snapshot.docs[snapshot.docs.length - 1]
      );

      if (!startAfterDoc) {
        return [];
      }

      firstPageSnapshot = await getDocs(
        query(q, startAfter(startAfterDoc), limit(pageSize))
      );
    }

    if (firstPageSnapshot.empty) {
      return [];
    }

    return firstPageSnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error fetching processing team:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};

export const getCardsCount = async (accountId = "", status = "") => {
  let q = await query(collection(db, "Cards"));
  if (status) {
    q = await query(collection(db, "Cards"), where("status", "==", status));
  }

  if (accountId) {
    q = await query(
      collection(db, "Cards"),
      where("accountId", "==", accountId)
    );
  }
  if (accountId && status) {
    q = await query(
      collection(db, "Cards"),
      where("accountId", "==", accountId),
      where("status", "==", status)
    );
  }
  const snapshot = await getCountFromServer(q);
  const count = snapshot.data().count ?? 0;

  return count >= 10000 ? 10000 : count;
}; // Import your Firestore configuration

export const getTotalCards = async (accountId = "") => {
  try {
    let q = collection(db, "Cards");

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error price group:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};
export const getUserCards = async (accountId = "") => {
  try {
    let q = collection(db, "Cards");
    if (accountId) {
      q = query(q, where("accountId", "==", accountId));
    }
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error price group:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};

export const getWalletAmmount = async (accountId = "") => {
  try {
    let q = collection(db, "Cards");
    if (accountId) {
      q = query(q, where("accountId", "==", accountId));
    }
    q = query(q, where("status", "==", "paid"));
    q = query(q, where("payoutStatus", "==", "pending"));

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error wallet amount:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};

export const getCards = async (
  accountId = "",
  status = "",
  pageNumber = 1,
  pageSize = 200,
  searchText = ""
) => {
  try {
    let q = collection(db, "Cards");

    // Apply where conditions based on the provided parameters
    if (searchText) {
      q = query(
        q,
        where("cardNo", ">=", searchText),
        where("cardNo", "<=", searchText + "\uf8ff")
      );
    } else {
      q = query(q, orderBy("date", "desc"));
    }
    // Apply additional conditions based on the provided parameters
    if (status) {
      q = query(q, where("status", "==", status));
    }

    if (accountId) {
      q = query(q, where("accountId", "==", accountId));
    }

    if (accountId && status) {
      q = query(
        q,
        where("accountId", "==", accountId),
        where("status", "==", status)
      );
    }

    // q = query(q, orderBy("cardNo", "desc"));
    // Order the query by the appropriate field
    // q = query(q, orderBy("id")); // Specify the field you want to order by

    // Calculate the start index for the page
    const startIndex = (pageNumber - 1) * pageSize;

    // Fetch the first page
    let firstPageSnapshot;

    if (pageNumber === 1) {
      // For the first page, directly apply limit
      firstPageSnapshot = await getDocs(query(q, limit(pageSize)));
    } else {
      // For subsequent pages, use startAfter with the last document from the previous page
      const startAfterDoc = await getDocs(query(q, limit(startIndex))).then(
        (snapshot) => snapshot.docs[snapshot.docs.length - 1]
      );

      // If there are no more documents to fetch, return an empty array
      if (!startAfterDoc) {
        return [];
      }

      firstPageSnapshot = await getDocs(
        query(q, startAfter(startAfterDoc), limit(pageSize))
      );
    }

    // If there are no documents, return an empty array
    if (firstPageSnapshot.empty) {
      return [];
    }

    // Extract and return the data from the documents
    return firstPageSnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error fetching cards:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};

export const getPriceGroup = async (
  pageNumber = 1,
  pageSize = 200,
  searchText = ""
) => {
  try {
    let q = collection(db, "PriceGroup");

    // Apply where conditions based on the provided parameters
    if (searchText) {
      q = query(
        q,
        where("name", ">=", searchText),
        where("name", "<=", searchText + "\uf8ff")
      );
    } else {
      q = query(q, orderBy("name", "desc"));
    }

    const startIndex = (pageNumber - 1) * pageSize;

    // Fetch the first page
    let firstPageSnapshot;

    if (pageNumber === 1) {
      // For the first page, directly apply limit
      firstPageSnapshot = await getDocs(query(q, limit(pageSize)));
    } else {
      // For subsequent pages, use startAfter with the last document from the previous page
      const startAfterDoc = await getDocs(query(q, limit(startIndex))).then(
        (snapshot) => snapshot.docs[snapshot.docs.length - 1]
      );

      // If there are no more documents to fetch, return an empty array
      if (!startAfterDoc) {
        return [];
      }

      firstPageSnapshot = await getDocs(
        query(q, startAfter(startAfterDoc), limit(pageSize))
      );
    }

    // If there are no documents, return an empty array
    if (firstPageSnapshot.empty) {
      return [];
    }

    // Extract and return the data from the documents
    return firstPageSnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error price group:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};

export const getTotalPriceGroups = async () => {
  try {
    let q = collection(db, "PriceGroup");
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error price group:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};

export const getTotalOffering = async (id) => {
  try {
    let q = collection(db, "Offerings");
    if (id) {
      q = query(q, where("priceGroup.id", "==", id));
    } else {
      q = query(q, where("priceGroup.isDefault", "==", true));
    }
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error price group:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};
export const getOffering = async (
  pageNumber = 1,
  pageSize = 200,
  searchText = ""
) => {
  try {
    let q = collection(db, "Offerings");

    // Apply where conditions based on the provided parameters
    if (searchText) {
      q = query(
        q,
        where("name", ">=", searchText),
        where("name", "<=", searchText + "\uf8ff")
      );
    } else {
      q = query(q, orderBy("name", "desc"));
    }

    const startIndex = (pageNumber - 1) * pageSize;

    // Fetch the first page
    let firstPageSnapshot;

    if (pageNumber === 1) {
      // For the first page, directly apply limit
      firstPageSnapshot = await getDocs(query(q, limit(pageSize)));
    } else {
      // For subsequent pages, use startAfter with the last document from the previous page
      const startAfterDoc = await getDocs(query(q, limit(startIndex))).then(
        (snapshot) => snapshot.docs[snapshot.docs.length - 1]
      );

      // If there are no more documents to fetch, return an empty array
      if (!startAfterDoc) {
        return [];
      }

      firstPageSnapshot = await getDocs(
        query(q, startAfter(startAfterDoc), limit(pageSize))
      );
    }

    // If there are no documents, return an empty array
    if (firstPageSnapshot.empty) {
      return [];
    }

    // Extract and return the data from the documents
    return firstPageSnapshot.docs.map((item) => item.data());
  } catch (error) {
    console.error("Error price group:", error);
    throw error; // Rethrow the error for handling at a higher level
  }
};

export const getTransectionHistoryCount = async (accountId = "") => {
  let q = await query(collection(db, "Cards"), where("status", "==", "paid"));
  if (accountId) {
    q = query(q, where("account.id", "==", accountId));
  }

  const snapshot = await getCountFromServer(q);
  const count = snapshot.data().count ?? 0;

  return count >= 10000 ? 10000 : count;
};

export const getTransactionHistory = async (
  pageNumber = 1,
  pageSize = 200,
  text = "",
  accountId = "",
  searhKey = "",
  filter = { start: "", end: "" }
) => {
  //   let start = new Date('2023-12-01');
  // let end = new Date('2023-12-31');
  let q = await query(
    collection(db, "Cards")
    // where(searhKey, ">=", text),
    // where(searhKey, "<=", text + "\uf8ff"),
  );

  if (searhKey) {
    q = query(
      q,
      where(searhKey, ">=", text),
      where(searhKey, "<=", text + "\uf8ff")
    );
  }

  if (filter.start && filter.end) {
    q = query(
      q,
      where("date", ">", new Date(filter.start)),
      where("date", "<", new Date(filter.end))
    );
  }
  q = query(q, where("status", "==", "paid"));

  if (accountId) {
    q = query(q, where("account.id", "==", accountId));
  }

  const startIndex = (pageNumber - 1) * pageSize;

  let firstPageSnapshot;

  if (pageNumber === 1) {
    firstPageSnapshot = await getDocs(query(q, limit(pageSize)));
  } else {
    const startAfterDoc = await getDocs(query(q, limit(startIndex))).then(
      (snapshot) => snapshot.docs[snapshot.docs.length - 1]
    );

    if (!startAfterDoc) {
      return [];
    }

    firstPageSnapshot = await getDocs(
      query(q, startAfter(startAfterDoc), limit(pageSize))
    );
  }

  if (firstPageSnapshot.empty) {
    return [];
  }

  return firstPageSnapshot.docs.map((item) => item.data());
};

export const getATMCardDetail = async (id) => {
  let q = await query(collection(db, "Cards"), where("id", "==", id));

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((item) => item.data());
};

export const getCardDetail = async (cardId) => {
  let q = await query(collection(db, "Cards"), where("id", "==", cardId));

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((item) => item.data());
};

export const getAdmin = async () => {
  let q = await query(
    collection(db, "Accounts"),
    where("accountType", "in", ["admin", "processing team"])
  );

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((item) => item.data());
};

const setInvisibleRecaptcha = () => {
  const recaptchaVerifier = new RecaptchaVerifier(
    "recaptcha_container",
    {
      size: "invisible",
      callback: (response) => {
        console.log("response", response);
      },
    },
    auth
  );
  window.recaptchaVerifier = recaptchaVerifier;
  recaptchaVerifier.render();
};

export const requestOtp = async (phoneNumber) => {
  console.log("phoneNumber", phoneNumber);
  setInvisibleRecaptcha();
  const appVerifier = window && window.recaptchaVerifier;
  await signInWithPhoneNumber(auth, phoneNumber, appVerifier)
    .then((confirmationResult) => {
      window.confirmationResult = confirmationResult;
      console.log("confirmationResult", confirmationResult);
    })
    .catch((error) => {
      console.log("confirmationResult", error);
    });
};

export const verifyOtp = async (otp) => {
  let _isSuccess = false;
  await window.confirmationResult
    .confirm(otp)
    .then((result) => {
      const user = result.user;
      _isSuccess = true;
    })
    .catch((error) => {
      console.log("error", error);
      _isSuccess = false;
    });

  return _isSuccess;
};
